import {fillDataNames} from "../../utils/graphUtil";

export function getAllProducts(sumdays) {
    if (!sumdays || sumdays.length === 0) {
        return [];
    }
    let allProducts = [];
    sumdays.forEach((sumday) => {

        const staffDetails = sumday.detailbyStaff;

        for (const staff in staffDetails) {
            const locations = staffDetails[staff].locations;

            for (const location in locations) {
                const products = locations[location].products;
                const timeSlots = products.timeSlot;
                Object.keys(timeSlots).forEach((timeSlot) => {
                    const timeSlotDetail = timeSlots[timeSlot];

                    Object.keys(timeSlotDetail).forEach((productKey) => {
                        let timeSlotDetailElement = timeSlotDetail[productKey];


                        if (timeSlotDetailElement && typeof timeSlotDetailElement === 'object') {
                            allProducts.push({
                                name: productKey,
                                ...timeSlotDetailElement
                            })
                        }
                    })
                })
            }
        }
    });
    return allProducts;

}

export  function fillNamesOfSumDays(sumUpDays, staffs, locations, products, optionLists, paymentModes, categories) {
    if (!sumUpDays || sumUpDays.length == 0 || !products || !staffs || !paymentModes || !locations || !optionLists || !categories) {
        return [];
    }
    let all = []
    sumUpDays.forEach((sumUpDay) => {
        if (sumUpDay.content) {
            const contentParsed = JSON.parse(sumUpDay.content);
            all.push({
                ...fillDataNames(contentParsed, staffs, locations, products, optionLists, paymentModes, categories),
                date: sumUpDay.dayDate
            });
        }
        else {
            all.push({
                date: sumUpDay.dayDate
            });
        }
    })


    return all;
    // return fillDataNames(sumUpDays, staffs, locations, products, []);
}

export async function getTimeSlotMap(sumdays, establishment) {
    if (!sumdays || sumdays.length === 0) {
        return [];
    }

    let timeSlotMap = {};
    sumdays.forEach((sumday) => {

        const staffDetails = sumday.detailbyStaff;

        for (const staff in staffDetails) {
            const locations = staffDetails[staff].locations;

            for (const location in locations) {
                const products = locations[location].products;
                const timeSlots = products.timeSlot;
                Object.keys(timeSlots).forEach((timeSlot) => {
                    const timeSlotDetail = timeSlots[timeSlot];
                    if (!timeSlotMap[timeSlot]) {
                        timeSlotMap[timeSlot] = [];
                    }
                    timeSlotMap[timeSlot].push(timeSlotDetail);


                })
            }
        }
    });
    return timeSlotMap;

}

export async function getAllProductsGlobal(sumdays, establishment) {
    if (!sumdays || sumdays.length === 0) {
        return [];
    }

    let allProducts = [];
    sumdays.forEach((sumday) => {

        const staffDetails = sumday.detailbyStaff;

        for (const staff in staffDetails) {
            const locations = staffDetails[staff].locations;

            for (const location in locations) {
                const products = locations[location].products;
                const timeSlots = products.timeSlot;
                Object.keys(timeSlots).forEach((timeSlot) => {
                    const timeSlotDetail = timeSlots[timeSlot];

                    Object.keys(timeSlotDetail).forEach((productKey) => {
                        let timeSlotDetailElement = timeSlotDetail[productKey];


                        if (timeSlotDetailElement && typeof timeSlotDetailElement === 'object') {
                            allProducts.push({
                                name: productKey,
                                ...timeSlotDetailElement,
                                location: location,
                                staff: staff,
                                timeSlot: timeSlot,
                                date: sumday.date,
                                establishment: establishment && establishment.name
                            })
                        }
                    })
                })
            }
        }
    });
    return allProducts;

}